export var Tools;
(function (Tools) {
    Tools["CROP"] = "crop";
    Tools["AI"] = "ai";
    Tools["FILTERS"] = "filters";
    Tools["ADJUSTMENTS"] = "adjustments";
    Tools["FRAMES"] = "frames";
    Tools["OVERLAYS"] = "overlays";
    Tools["TEXT"] = "text";
    Tools["STICKERS"] = "stickers";
    Tools["BRUSH"] = "brush";
})(Tools || (Tools = {}));
